import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { useUpdateWorkFlowNcrMutation } from "store/slices/apis/keyNcrSlice";

export default function ApproveNcrComponent(props) {
  const { open, cancel, rowData, type, openNotification, refetch } = props;
  const theme = useTheme();
  const [comment, setComment] = React.useState("");

  const [updateWorFlowNcr, updateWorkFlowNcrRes] = useUpdateWorkFlowNcrMutation();

  const handleApprove = () => {
    let formData = {
      Comment: comment,
      ParentId: rowData?.id,
      Status: "Approve",
      Type: type,
      LinkUrl: `http://pmis-tool.s3-website.eu-north-1.amazonaws.com/verify/ncr/${rowData?.id}`,
      data: JSON.stringify(rowData),
    };

    updateWorFlowNcr(formData);
  };

  React.useEffect(() => {
    if (updateWorkFlowNcrRes?.isSuccess) {
      if (updateWorkFlowNcrRes?.data?.status == "Success") {
        openNotification(updateWorkFlowNcrRes?.data?.message, "success");
        setComment("");
        cancel();
        refetch();
      } else {
        openNotification(updateWorkFlowNcrRes?.data?.message, "error");
      }
    }
  }, [updateWorkFlowNcrRes?.isSuccess]);
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={cancel}
        disableEnforceFocus
        disableRestoreFocus
        aria-labelledby="draggable-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "20px",
            color: "#252525",
            paddingBottom: 0,
          }}
          id="draggable-dialog-title"
        >
          Approve
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          }}
        >
          <IoMdClose style={{ fontSize: "20px" }} />
        </IconButton>
        <DialogContent>
          <DialogContentText
            sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
          >
            <TextField
              id="outlined-multiline-static"
              label="Comment (Optional)"
              name="Comment"
              multiline
              fullWidth
              rows={3}
              value={comment}
              slotProps={{ inputLabel: { shrink: true } }}
              onChange={(event) => {
                setComment(event?.target?.value);
              }}
              variant="filled"
              sx={{
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#696969",
                  fontSize: "14px",
                },
              }}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button
                        variant="outlined"
                        onClick={cancel}
                        sx={{
                            color: `${theme?.customSettings?.themeColor}`,
                            fontSize: '16px',
                            fontWeight: '500',
                            textTransform: 'none',
                            border: `1px solid ${theme?.customSettings?.themeColor}`
                        }}
                    >
                        Cancel
                    </Button> */}
          <Button
            variant="contained"
            onClick={handleApprove}
            loading={updateWorkFlowNcrRes?.isLoading}
            sx={{
              backgroundColor: `${theme?.customSettings?.themeColor}`,
              color: "#fff",
              fontSize: "16px",
              fontWeight: "500",
              textTransform: "none",
            }}
          >
            Approve
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
